// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"7fe8c6c0","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};